export default __webpack_public_path__ + "static/stanford-fff35a1b335ea368bb38bf907341b08b.png";